/* esm.sh - vfile-message@4.0.3 */
export * from "/*vfile-message@4.0.3/esnext/vfile-message.mjs";
